module.exports = __webpack_public_path__ + "9efa6821b330f8b845564de576bf751c.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/media/8/8.jpg
// module id = 585
// module chunks = 0